import {
  COURIER_TRACKING_EVENTS,
  TInvitationSendSuccess,
  TInvitationSendStart,
  TInvitationSendInviteAgain,
  TInvitationDisconnectStart,
  TInvitationDisconnectSuccess,
  TInvitationGuestConnect,
  TInvitationGuestDecline,
  TInvitationRemoveSuccess,
  TInvitationRemoveStart,
} from './index';
import { trackByEvent } from '../../../tracking/services';
import { TRACKING_DEFAULTS, COMPONENT_TYPE } from '../../../tracking/constant';

/* Tracking Invitation Send Success  */
const trackInvitationSendSuccess = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationSendSuccess>(
      COURIER_TRACKING_EVENTS.INVITATION_SEND_SUCCESS.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_SEND_SUCCESS
          .component_type as COMPONENT_TYPE,
        form_action: COURIER_TRACKING_EVENTS.INVITATION_SEND_SUCCESS.action,
        language: language || '',
        courierDetail: courierDetail,
        country: country || '',
      }
    );
  } catch (error) {
    console.error('invitation send success Error: ', error);
  }
};
/* Tracking Invitation Send Start  */
const trackInvitationSendStart = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationSendStart>(
      COURIER_TRACKING_EVENTS.INVITATION_SEND_START.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_SEND_START
          .component_type as COMPONENT_TYPE,
        form_action: COURIER_TRACKING_EVENTS.INVITATION_SEND_START.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation send start Error: ', error);
  }
};

const trackInvitationSendInviteAgainStart = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationSendInviteAgain>(
      COURIER_TRACKING_EVENTS.INVITATION_SEND_INVITE_AGAIN_START.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS
          .INVITATION_SEND_INVITE_AGAIN_START.component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_SEND_INVITE_AGAIN_START.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation send invite again start Error: ', error);
  }
};

const trackInvitationSendInviteAgainSuccess = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationSendInviteAgain>(
      COURIER_TRACKING_EVENTS.INVITATION_SEND_INVITE_AGAIN_SUCCESS.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS
          .INVITATION_SEND_INVITE_AGAIN_SUCCESS
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_SEND_INVITE_AGAIN_SUCCESS.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation send invite again success Error: ', error);
  }
};

const trackInvitationDisconnectStart = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationDisconnectStart>(
      COURIER_TRACKING_EVENTS.INVITATION_DISCONNECT_START.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_DISCONNECT_START
          .component_type as COMPONENT_TYPE,
        form_action: COURIER_TRACKING_EVENTS.INVITATION_DISCONNECT_START.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation disconnect start Error: ', error);
  }
};

const trackInvitationDisconnectSuccess = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationDisconnectSuccess>(
      COURIER_TRACKING_EVENTS.INVITATION_DISCONNECT_SUCCESS.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_DISCONNECT_SUCCESS
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_DISCONNECT_SUCCESS.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation disconnect success Error: ', error);
  }
};

const trackInvitationGuestConnectStart = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationGuestConnect>(
      COURIER_TRACKING_EVENTS.INVITATION_GUEST_CONNECT_START.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_GUEST_CONNECT_START
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_GUEST_CONNECT_START.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation guest connect Error', error);
  }
};

const trackInvitationGuestConnectSuccess = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationGuestConnect>(
      COURIER_TRACKING_EVENTS.INVITATION_GUEST_CONNECT_SUCCESS.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME, // Use on Delete
        component_type: COURIER_TRACKING_EVENTS.INVITATION_GUEST_CONNECT_SUCCESS
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_GUEST_CONNECT_SUCCESS.action, // Remove start | rem 
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation guest connect Error', error);
  }
};

const trackInvitationGuestDeclineStart = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationGuestDecline>(
      COURIER_TRACKING_EVENTS.INIVTATION_GUEST_DECLINE_START.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INIVTATION_GUEST_DECLINE_START
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INIVTATION_GUEST_DECLINE_START.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation guest decline Error', error);
  }
};

const trackInvitationGuestDeclineSuccess = (
  language?: string,
  country?: string,
  courierDetail?: any
) => {
  try {
    trackByEvent<TInvitationGuestDecline>(
      COURIER_TRACKING_EVENTS.INVITATION_GUEST_DECLINE_SUCCESS.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_GUEST_DECLINE_SUCCESS
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_GUEST_DECLINE_SUCCESS.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
      }
    );
  } catch (error) {
    console.error('invitation guest decline Error', error);
  }
};

const trackInvitationRemoveStart = (
  language?: string,
  country?: string,
  courierDetail?: any,
  countTotal?: number,
) => {
  try {
    trackByEvent<TInvitationRemoveStart>(
      COURIER_TRACKING_EVENTS.INVITATION_REMOVE_START.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_REMOVE_START
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_REMOVE_START.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
        form_countsTotal: countTotal || 0
      }
    );
  } catch (error) {
    console.error('invitation remove start error', error);
  }
};

const trackInvitationRemoveSuccess = (
  language?: string,
  country?: string,
  courierDetail?: any,
  countTotal?: number
) => {
  try {
    trackByEvent<TInvitationRemoveSuccess>(
      COURIER_TRACKING_EVENTS.INVITATION_REMOVE_SUCCESS.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        event_type: COURIER_TRACKING_EVENTS.TYPE,
        component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: COURIER_TRACKING_EVENTS.INVITATION_REMOVE_SUCCESS
          .component_type as COMPONENT_TYPE,
        form_action:
          COURIER_TRACKING_EVENTS.INVITATION_REMOVE_SUCCESS.action,
        language: language || '',
        country: country || '',
        courierDetail: courierDetail,
        form_countsTotal: countTotal || 0
      }
    );
  } catch (error) {
    console.error('invitation remove start error', error);
  }
}


export {
  trackInvitationSendSuccess,
  trackInvitationSendStart,
  trackInvitationSendInviteAgainStart,
  trackInvitationSendInviteAgainSuccess,
  trackInvitationDisconnectStart,
  trackInvitationDisconnectSuccess,
  trackInvitationGuestConnectStart,
  trackInvitationGuestConnectSuccess,
  trackInvitationGuestDeclineStart,
  trackInvitationGuestDeclineSuccess,
  trackInvitationRemoveStart,
  trackInvitationRemoveSuccess
};
